export default function ReviewCard(props){
    const data = {
        name:"Michèle MINKOE",
        stars: 5,
        text: "Merci beaucoup à LM PLATINUM ESTATES pour la facilitation à trouver des terrains et maisons sans fournir des efforts épuisants 🙏. Aussi ils sont transparents, présents et surtout minutieux durant  toute la procédure d'acquisition. Je vous recommande vivement cette agence immobilière ☺️ …"
    }
    return (
        <>
        <div id="review-card">
            <div id='name'>
                {props.data.name}
            </div>
            <div id='stars'>
                <img src="star.svg"/>
                <img src="star.svg"/>
                <img src="star.svg"/>
                <img src="star.svg"/>
                <img src="star.svg"/>
            </div>
            <div id='text' title={props.data.text}>
                {props.data.text}
            </div>
        </div>
        </>
    )
}